import { getLayoutByName } from '@app-store'
import { getEntityDataByIdEmbedded } from '../apis/entityData.api'
import { ENTITY_NAME } from './constants'

export const getMigrationStatus = async (id: number, isWorkflow = false) => {
  if (isWorkflow) {
    const res = await getEntityDataByIdEmbedded(
      ENTITY_NAME?.CASE_LOWER,
      Number(ENTITY_NAME?.CASE_ENTITY_ID),
      [ENTITY_NAME?.MIGRATED],
      id
    )
    return res?.data?.migrated ?? false
  }
  return false

  const res = await getEntityDataByIdEmbedded(
    ENTITY_NAME?.CASE_LOWER,
    32,
    [ENTITY_NAME?.MIGRATED],
    id
  )
  return res?.data?.migrated ?? false
}

export const getMigratedLayoutId = async () => {
  const res = await getLayoutByName({
    entityId: '32',
    layoutName: ENTITY_NAME?.MIGRATED_LAYOUT_NAME,
  })
  return res?.data?.id ?? ''
}
